import { useQuery } from "@tanstack/react-query";
import { IGetAllUsersList, IRoleManagementRow } from "../utils/types";
import { apiFetch } from "@core/index";
import { buildQueryParams } from "@shared/utils/functions";
import { apiEndpoint } from "../utils/constants";
import { enqueueSnackbar } from "notistack";

export type RoleManagementListResponse = {
  data: IRoleManagementRow[];
  pagination: {
    total: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  };
};

export const useGetAllUsersList = (config: IGetAllUsersList) => {
  return useQuery<
    RoleManagementListResponse,
    Error,
    RoleManagementListResponse
  >({
    queryKey: [
      "roleManagementList",
      config.data.pageNumber,
      config.data.pageSize,
      config.data.searchQuery ?? "",
      config.data.orderBy ?? "",
      config.data.order ?? "",
    ],
    queryFn: async () => {
      const queryString = buildQueryParams(config.data);
      const url = `${apiEndpoint}?${queryString}`;

      try {
        const data = await apiFetch<RoleManagementListResponse>(url);
        return data;
      } catch (error) {
        const message =
          error instanceof Error
            ? error.message
            : "Failed to fetch the User list.";

        enqueueSnackbar(message, {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        });
        throw error;
      }
    },
  });
};
